import { helper } from '@ember/component/helper';
import { numberToUserDisplay } from '@ebiz/pretty-num';

export default helper(function stdnum(
  [num],
  { digits = 3, showZeroes = false, supplySpace = false, fixedDigits = false }: UserDisplayOptions,
) {
  return numberToUserDisplay(num as number, 'Standard', digits, {
    showZeroes: showZeroes,
    supplySpace: supplySpace,
    fixedDigits: fixedDigits,
  });
});
